export class SignatureCertificate {

  public subjectName: string;
  public ckId: string;
  public pem: string;
  public notAfter: string;
  public notBefore: string;
  public support: string;

  constructor() {
  }

  public isEmpty(): boolean {
    return this.subjectName === undefined || this.subjectName.length === 0;
  }
}
